export class FormatCurrencyService {
	static  format  (
		amount: number,
		userCurrency: string,
	): string {
		try {
			return new Intl.NumberFormat('en-US', {
				style: "currency",
				currency: userCurrency,
				maximumFractionDigits: 0,
			}).format(amount);
		} catch (err) {
			console.warn("Failed to format tuition", err);
			return `${amount} ${userCurrency}`;
		}
	}
}